<button
  class="ui-action-card"
  type="button"
  [class.ui-action-card-neutral]="isNeutral()"
  [class.ui-action-card-primary]="isPrimary()"
  [class.ui-action-card-success]="isSuccess()"
  [class.ui-action-card-warning]="isWarning()"
  [class.ui-action-card-danger]="isDanger()"
  [attr.aria-label]="ariaLabel()"
  [disabled]="disabled()"
  (click)="handleSelected($event)"
>
  <span class="ui-action-card-leading">
    <ng-content select="[uiActionCardLeading]" />
  </span>
  <span class="ui-action-card-copy">
    @if (hasMeta()) {
      <span class="ui-action-card-meta">{{ meta() }}</span>
    }
    <span class="ui-action-card-title">{{ title() }}</span>
    @if (hasDescription()) {
      <span class="ui-action-card-description">{{ description() }}</span>
    }
  </span>
  <span class="ui-action-card-trailing">
    <ng-content select="[uiActionCardTrailing]" />
  </span>
</button>
